import {
  RESET_CREATE,
  UPDATE_CREATE_PARAMS,
  DEFAULT_PARAMS_CREATE,
} from "../actions/types";
// import { createParams } from "../testData/createParams";

const initialState = {
  // simulation_type: null, // "single_point" or "multi_points" --> default null
  // geometry: null, // always one geometry, for both cases  --> default null
  // db_points: [], // array of one obj or multiple obsj with "lat" and "lon" --> default []
  // simulation_years: createParams()["simulation_years"],
  // PV_run: createParams()["PV_run"],
  // PV_with_wind: createParams()["PV_with_wind"],
  // WT_run: createParams()["WT_run"],
  // PV_axes: createParams()["PV_axes"],
  // WT_model: createParams()["WT_model"],
  // PV_params: createParams()["PV_params"],
  // WT_params: createParams()["WT_params"],
  // battery_params: createParams()["battery_params"],
  // PV_paramsFin: createParams()["PV_paramsFin"],
  // WT_paramsFin: createParams()["WT_paramsFin"],
  // battery_paramsFin: createParams()["battery_paramsFin"],
  // load_id: null, // default null
  // correction_coeff: 1,
  // load: null,
  // efficiency_ageing: createParams()["efficiency_ageing"],
  // tax_reduction_params: createParams()["tax_reduction_params"],
  // environmental_params: createParams()["environmental_params"],
  // label: "",
  // description: "",
  // project: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case DEFAULT_PARAMS_CREATE:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_CREATE_PARAMS:
      console.log(action.payload);
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    default:
      return state;
  }
}
